module.exports = __webpack_public_path__ + "img/error-500-sm.19b62db6.jpg";